import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export async function fetchServerVersion() {
  const res = await fetch(`${API_BASE}/version`);
  return res.json();
}

export async function confirmActive(token, email) {
  const res = await apiFetch(`${API_BASE}/confirm-active`, {
    method: 'POST',
    body: JSON.stringify({ token, email })
  });
  return res.json();
}

// Ensures CSRF cookie is set before making a POST request
export async function ensureCsrfToken() {
  try {
    await apiFetch(`${API_BASE}/csrf`, { method: 'GET' });
  } catch (e) {
    // Ignore errors, just want the cookie
  }
}